import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { ProgressContainer, ProgressItem } from './css';

const TabsBar = ({ steps = [], current = '', onTabChange }) => (
  <ProgressContainer>
    {steps.map((step, index) => (
      <ProgressItem key={index} className={`${step === current ? 'active' : ''}`} width={steps.length}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <span className="title" step={step} onClick={(e) => onTabChange(e.target.attributes.step.value)}>{t(step)}</span>
        <span className="progress-bar" />
      </ProgressItem>
    ))}
  </ProgressContainer>
);

TabsBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string),
  current: PropTypes.string,
  onTabChange: PropTypes.func,
};

export default TabsBar;
